// extracted by mini-css-extract-plugin
module.exports = {"AlertDialogWrapper":"Dialog_AlertDialogWrapper__yWkY_","textWordBreak":"Dialog_textWordBreak__qadI8"};